'use strict';

import _ from "lodash";
import Firebase from "firebase";
import CSV from "../js/csv";
import localForage from "localForage";

var hintDataSourceEnum = Object.freeze({ "none": 0, "firebase": 1, "htmlFile": 2, "googleDocs": 3 });

var initData = {
    hintDataSource: hintDataSourceEnum.firebase,

    useLocalStorageCache: true
};

let hintData = [];

let synonymsDictionary = {
    
};

let date = undefined;

let promises = {
    hintDataLoadPromise: undefined,
    synonymsDataLoadPromise: undefined
};

var api = {
    /**
     * Loads hint data from database, and saves it in client's local storage
     * @param {boolean} forceReload Forces reloading data from database, even if it already exists in client's localStorage
     * @returns {Promise} Promise, resolved when data is loaded
     */
    loadHintData: function (forceReload) {
        if(promises.hintDataLoadPromise === undefined || forceReload){
            promises.hintDataLoadPromise = $.Deferred();

            var that = this;

            localForage.getItem("hintData").then(function(hintDataFromLocalStorage){
                if (
                    hintDataFromLocalStorage === undefined ||
                    hintDataFromLocalStorage === null ||
                    forceReload
                ) {
                    var config = {
                        apiKey: "AIzaSyDtZ3S1i76PLqNQHTXt0OJmfBAwKXIhjEc",
                        authDomain: "demo1-4643d.firebaseapp.com",
                        databaseURL: "https://demo1-4643d.firebaseio.com",
                        projectId: "demo1-4643d",
                        storageBucket: "demo1-4643d.appspot.com",
                        messagingSenderId: "174726021868"
                    };
    
                    if (!Firebase.apps.length) {
                        Firebase.initializeApp(config);
                    }
    
                    var ref = Firebase.database().ref("/");
    
                    ref.once(
                        "value",
                        function (data) {
                            localForage.setItem("hintData", JSON.stringify(data.val())).then(function(){
                                hintData = data.val();
    
                                promises.hintDataLoadPromise.resolve();
                            });
                        },
                        function (errorObject) {
                            console.log("The read failed: " + errorObject.code);
    
                            promises.hintDataLoadPromise.reject();
                        }
                    );
                } else {
                    hintData = JSON.parse(hintDataFromLocalStorage);
    
                    promises.hintDataLoadPromise.resolve();
                }
            });
        }

        return promises.hintDataLoadPromise;
    },

    /**
     * Loads synonyms data from external source
     * @returns {Promise} Promise, resolved when data is loaded
     */
    loadSynonymsData: function(){
        if(promises.synonymsDataLoadPromise === undefined){
            promises.synonymsDataLoadPromise = $.Deferred();

            $.get("https://sheets.googleapis.com/v4/spreadsheets/1_VCHTq-p5E4zlN-yd1yx0JNgX_cSWEI7w8NgpAPaVAY/values/Synonyms!B2:I?key=AIzaSyArn7m8-L2joQPP2YqJOKmiSqp5kaV4HTA")
            .done(function(data){
                console.log(data);
    
                data.values.forEach(function(d){
                    var key = d[0].toString();
    
                    if(synonymsDictionary[key] == null){
                        synonymsDictionary[key] = [];
                    }
    
                    synonymsDictionary[key].push({
                        type: d[1],
                        asIn: d[2],
                        allSynonymsString: (d[3] != null && d[3] != '') ? d[3].split(';') : [],
                        high: (d[4] != null && d[4] != '') ? d[4].split(';') : [],
                        medium: (d[5] != null && d[5] != '') ? d[5].split(';') : [],
                        low: (d[6] != null && d[6] != '') ? d[6].split(';') : [],
                        examples: (d[7] != null && d[7] != '') ? d[7].split(';') : []
                    });
                });
    
                console.log(synonymsDictionary);
    
                promises.synonymsDataLoadPromise.resolve();
            })
            .fail(function(data){
                debugger;
    
                promises.synonymsDataLoadPromise.fail();
            });
        }

        return promises.synonymsDataLoadPromise;
    },

    /**
     * Returns hints for tag, passed as parameter
     * @param {string} inputValue String containing the tag, for example [SAD] or [Breathing;Sad]. String case, doesn't matter
     * @returns {Array} Array of hints, ordered by action tag
     */
    getHints: function (inputValue) {
        var dataToReturn = [];

        var text = inputValue.match(/[^[\]]+(?=])/g);

        if (text !== null && text !== undefined) {
            text = text.map(function (d) {
                return d.toLowerCase();
            });

            for (var i = 0, j = text.length; i < j; ++i) {
                var split = text[i].split(";");

                if (split.length === 1) {
                    var data = _.filter(hintData, function (d) {
                        return (
                            _.indexOf(
                                Object.values(d.ExpressionTags).map(function (d) {
                                    return d.toLowerCase();
                                }),
                                split[0]
                            ) !== -1
                        );
                    });

                    if (data.length > 0) {
                        dataToReturn = dataToReturn.concat(data);
                    }
                } else {
                    var data = _.filter(hintData, function (d) {
                        var dataToReturn = false;

                        if (split[1] === "") {
                            dataToReturn = d.ActionTag.toLowerCase() === split[0];
                        } else {
                            dataToReturn =
                                d.ActionTag.toLowerCase() === split[0] &&
                                _.indexOf(
                                    Object.values(d.ExpressionTags).map(function (d) {
                                        return d.toLowerCase();
                                    }),
                                    split[1]
                                ) !== -1;
                        }

                        return dataToReturn;
                    });

                    if (data.length > 0) {
                        dataToReturn = dataToReturn.concat(data);
                    }
                }
            }
        }

        dataToReturn = _.orderBy(dataToReturn, ["ActionTag"], ["asc"]);

        var groupedData = _.groupBy(dataToReturn, "ActionTag");

        var iterator = 0;
        var templateData = _.map(groupedData, function (data) {
            var dataToReturn = {
                id: ++iterator,
                actionTag: data[0].ActionTag,
                values: []
            };

            for (var i = 0, j = data.length; i < j; ++i) {
                dataToReturn.values.push(data[i].Value);
            }

            return dataToReturn;
        });

        dataToReturn = templateData;

        return dataToReturn;
    },

    /**
     * Returns synonyms for word, passed as parameter
     * @param {string} inputValue String containing the word, for which to find synonyms, for example: sighed
     * @returns {Array} Array of object containign synonyms data
     */
    getSynonyms: function(inputValue){
        var dataToReturn = [];

        var foundData = synonymsDictionary[inputValue];

        if(foundData !== undefined){
            let i=0;

            foundData.forEach(x => {
                dataToReturn.push({
                    id: ++i,
                    actionTag: inputValue,
                    type: x.type,
                    asIn: x.asIn,
                    valuesAll: (x.high.length > 0 || x.medium.length > 0 || x.low.length > 0) ? [] :  x.allSynonymsString,
                    valuesHigh: x.high,
                    valuesMedium: x.medium,
                    valuesLow: x.low
                });
            });
        }

        return dataToReturn;
    },

    /**
     * Returns synonyms dictionary
     * @returns {object} Synonyms dictionary
     */
    getSynonymsDictionary: function(){
        return synonymsDictionary;
    },

    /**
     * Return all the keys (words) from synonym dictionary, sorted by value
     * @returns {object} All keys from synonyms dictionary, sorted by value
     */
    getSynonymsKeys: function(){
        var dataToReturn = [];

        for (let k in synonymsDictionary){
            if (synonymsDictionary.hasOwnProperty(k)) {
                k = k.split(';')[0];

                if(dataToReturn.indexOf(k) === -1){
                    dataToReturn.push(k);
                }
            }
        }

        return dataToReturn.sort();
    },

    /**
     * Returns example sentances for given word, uses synonym data
     * @param {string} word Word to get data for
     * @returns {Array} Array containing synonym sentances
     */
    getExampleSentances: function(word){
        var dataToReturn = [];

        var foundData = synonymsDictionary[word];

        if(foundData !== undefined){
            let i=0;

            foundData.forEach(x => {
                dataToReturn = dataToReturn.concat(x.examples);
            });
        }

        return dataToReturn;
    },

    /**
     * Loads hints from provided CSV HTML file object
     * @param {object} fileObject HTML file object containing data to load
     */
    loadHintDataFromCsv: function (fileObject) {
        let loadedHintData = [];

        CSV.fetch({
            file: fileObject.files[0]
        }).done(function (dataset) {
            for (var i = 0, j = dataset.records.length; i < j; ++i) {
                var currentRecord = dataset.records[i];

                var dataToAdd = {
                    Value: currentRecord[0],

                    ActionTag: currentRecord[2],

                    ExpressionTags: currentRecord[3].split(";")
                };

                loadedHintData.push(dataToAdd);
            }

            hintData = loadedHintData;

            localForage.setItem("hintData", JSON.stringify(hintData));
        });
    }
};

export default function () {
    return api;
};


// WEBPACK FOOTER //
// ./src/js/storyProcessor.js